import { render, staticRenderFns } from "./RewardApproval.vue?vue&type=template&id=04189da4"
import script from "./RewardApproval.vue?vue&type=script&lang=js"
export * from "./RewardApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports